<template>
  <div>
    <b-card-body>
      <b-card class="mapEditorContainer">
        <div>
          <div class="mt-2" id="filter-box">
            <label for="filter-tree">Filtro: </label>
            <input
              type="text"
              id="filter-tree"
              class="ml-1"
              v-model="treeFilter"
            />
          </div>
          <div>
            <div class="col1Header">ATRIBUTOS</div>
          </div>
          <div class="basicArea">
            <Loading v-if="this.waiting" />
            <tree
              v-else
              class="treeMapSection"
              ref="tree"
              :data="lastMap == 'I' ? items.input : items.output"
              @node:dblclick="onNodeSelect"
              :options="treeOptions"
              :filter="treeFilter"
            >
              <span class="tree-text grid" slot-scope="{ node }">
                <template v-if="!node.hasChildren()">
                  <span class="tree-text rootStyle">
                    <div class="col1">
                      <b>{{ node.data.name }}</b>
                    </div>
                  </span>
                </template>
                <template v-else>
                  <span class="tree-text rootStyle" v-if="node.data.root == 1">
                    <div class="col1">
                      <b>{{ node.data.name }}</b>
                    </div>
                  </span>
                </template>
              </span>
            </tree>
          </div>
        </div>
        <div class="groupRow3">
          <b-input
            class="b-input-pentagro"
            disabled
            v-model="nodeSelected.nameSelected"
          ></b-input>
          <b-input
            class="input-pentagro"
            disabled
            v-model="nodeSelected.value"
          ></b-input>
          <img
            v-if="this.nodeSelected.value"
            id="closeModalPassword"
            class="float-right"
            src="@/assets/assinarEconfirmar.png"
            style="margin-left: 30px"
            :title="$t('confirmar')"
            :alt="$t('confirmar')"
            @click="confirmSelected"
          />
          <img
            id="closeModalPassword"
            class="float-right"
            src="@/assets/sair.png"
            style="margin-left: 30px"
            :title="$t('cancelar')"
            :alt="$t('cancelar')"
            @click="$bvModal.hide('modalProductionPlanMapEditor')"
          />
        </div>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Tree from "liquor-tree";
import Loading from "@/components/template/Loading.vue";

export default {
  name: "ProductionPlanMapEditor",

  inject: ["getModelTreeStructure"],

  components: { Tree, Loading },

  props: {
    lastMap: String,
  },

  data: function () {
    return {
      waiting: false,
      xml: {},
      items: {},
      treeFilter: "",
      treeOptions: {
        filter: {
          emptyText: "Sem resultados!",
          plainList: false,
          showChildren: true,
          matcher(query, node) {
            return new RegExp(query, "i").test(node.data.name);
          },
        },
      },
      nodeSelected: {
        keySelect: 0,
        nameSelected: "",
      },
    };
  },
  methods: {
    onNodeSelect(node) {
      if (node.data.root != 1) {
        this.nodeSelected.nameSelected = node.data.name;
        this.nodeSelected.value = node.data.key;
      }
    },

    confirmSelected() {
      this.$emit("mapSelected", this.nodeSelected.value);
      this.$bvModal.hide("modalProductionPlanMapEditor");
    },

    txtLimits(str) {
      if (str.length > 21) {
        return str.substring(0, 19) + " ...";
      }
      return str;
    },
  },
  created() {
    this.waiting = true;
  },
  async mounted() {
    this.items = await this.getModelTreeStructure();
    setTimeout(() => {
      this.waiting = false;
    }, 300);
  },
};
</script>

<style scoped>
.mapEditorContainer {
  max-width: 100%;
  min-width: 100px;
  height: 32rem;
}

.basicArea {
  height: 250px;
  margin-bottom: 15%;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.col1Header {
  max-width: 100%;
  height: 30px;
  font-weight: 500;
  margin-bottom: 5px;
  text-align: center;
  background: black;
  color: white;
}

.groupRow3 {
  margin-top: 10%;
  display: flex;
  flex-wrap: nowrap;
}

.groupRow3 img {
  cursor: pointer;
}

.tree-text {
  display: grid;
  font-family: Arial;
  font-size: 14pt;
  margin-right: 40px;
}

.rootStyle {
  font-weight: 500;
}

.col1 {
  max-width: 600px;
}

.headerDash {
  display: grid;
  background-color: rgba(0, 0, 0);
  color: white;
  height: 24px;
}

#filter-tree {
  border: 2px solid black;
  border-radius: 4px;
}

.txtLimit {
  font-size: 0.8em;
}

img {
  max-height: 35px;
}
.b-input-pentagro {
  display: none;
}

.treeMapSection {
  max-height: 120%;
  overflow-y: auto;
  margin: 0px auto;
  box-shadow: 0 0 3px #0003;
}

@media only screen and (max-width: 770px) {
  .inputFileGroup {
    max-width: 300px;
  }
}
</style>
